export function defined(value) {
    return typeof value !== 'undefined';
}
export function nullish(...values) {
    for (const value of values) {
        if (value === null || !defined(value)) {
            return true;
        }
    }
    return false;
}
export function getDefinedFallback(prop, fallback) {
    return defined(prop) ? prop : typeof fallback === 'function' ? fallback() : fallback;
}
//# sourceMappingURL=defined.js.map